const roadmapPage = {
  title: "Дорожная карта",
  description: "Фазы разработки vBrain.io",
  back: "Назад",
  openInNotion: "Открыть в Notion",
  taskCount: "элементов",
  effort: "Трудозатраты",
  goal: "Цель",
  epic: "Эпик",
  sprint: "Спринт",
  task: "Задача",
  portfolio: "Портфель",
  project: "Проект",
  subTask: "Подзадача",
  notStarted: "Не начато",
  inProgress: "В процессе",
  complete: "Завершено",
  allItems: "Все элементы",
  noItems: "Нет элементов на этом уровне",
  drillDown: "Показать",
  breadcrumbHome: "Цели",
  viewHierarchy: "Иерархия",
  viewPortfolio: "По портфелю",
  viewStatus: "По статусу",
  viewSprint: "По спринту",
  noStatus: "Без статуса",
  portfolioCount: "портфелей",
  projectCount: "проектов",
  sprintCount: "спринтов",
  doneLabel: "завершено",
  assignedTasks: "назначено",
  unassignedTasks: "не назначено",
  unassignedTasksTitle: "Неназначенные задачи",
} as const;
export default roadmapPage;
